import {
  buildCompactSearchLabel,
  resolveCategoryLabel,
} from './buscadorSearchDisplay';
import { normalizeFiltersForSearchPayload } from './buscadorUrlState';

const STORAGE_KEY = 'buscador_recent_v2';
const MAX_RECENT = 8;

export const saveRecentSearch = (filters, filtrosAtributos = {}, options = {}) => {
  try {
    const entry = {
      filters: normalizeFiltersForSearchPayload(filters),
      filtrosAtributos: { ...filtrosAtributos },
      label: options.label || null,
      ts: Date.now(),
    };
    const raw = localStorage.getItem(STORAGE_KEY);
    const list = raw ? JSON.parse(raw) : [];
    const signature = JSON.stringify({ filters: entry.filters, filtrosAtributos: entry.filtrosAtributos });
    const filtered = list.filter((item) => {
      const sig = JSON.stringify({ filters: item.filters, filtrosAtributos: item.filtrosAtributos || {} });
      return sig !== signature;
    });
    filtered.unshift(entry);
    localStorage.setItem(STORAGE_KEY, JSON.stringify(filtered.slice(0, MAX_RECENT)));
  } catch {
    // ignore quota / private mode
  }
};

export const loadRecentSearches = () => {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    return raw ? JSON.parse(raw) : [];
  } catch {
    return [];
  }
};

export const clearRecentSearches = () => {
  try {
    localStorage.removeItem(STORAGE_KEY);
  } catch {
    // ignore
  }
};

export const describeRecentSearch = (entry, { categoryOptions = [] } = {}) => {
  if (entry?.label) return entry.label;
  const f = entry?.filters || {};
  const categoryLabel = resolveCategoryLabel(f.id_categoria, categoryOptions);
  return buildCompactSearchLabel({
    filters: f,
    filtrosAtributos: entry?.filtrosAtributos || {},
    categoryLabel,
  });
};
